var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3a3 3 0 013-3h12a3 3 0 013 3v8a3 3 0 01-3 3H6.333L3 16v-2a3 3 0 01-3-3V3zm7.383 7.506l.149-2.233 3.835-3.674c.167-.157-.036-.244-.26-.087l-4.74 3.165-2.042-.678c-.444-.146-.452-.47.093-.696l7.984-3.26c.37-.147.693.087.572.685l-1.358 6.79c-.103.478-.37.597-.75.372L8.797 9.273 7.8 10.291c-.111.117-.203.215-.416.215z",
    fill: "#23024D"
  })));
}
export default SvgTelegram;